import { useTranslation } from "react-i18next";

// Types
import type { TOptionsBase } from "i18next";
import { useCallback } from "react";

type DynamicTranslation = (
  key: string,
  options?: TOptionsBase & Record<string, unknown>
) => string;

const useCustomTranslation = (customPrefix: string) => {
  const { t } = useTranslation();

  const prefixedT = useCallback(
    (path: string, options?: TOptionsBase & Record<string, unknown>) => {
      const key: string = `${customPrefix}.${path}`;
      // Prefixes are runtime values, so this key cannot use i18next's static-key overload.
      const translate = t as DynamicTranslation;

      return translate(key, options);
    },
    [customPrefix, t]
  );

  return { t, prefixedT };
};

export default useCustomTranslation;
